<template>
  <div>
    <v-layout wrap justify-center>
      <!-- Desktop Header -->
      <v-flex xs12 sm12 md12 lg12 xl12 class="hidden-sm-and-down">
          <v-layout wrap justify-center class="fill-height">
            <v-flex xs12 sm12 md2 lg2 xl2 class="d-flex justify-center align-center" pb-2>
              <v-img
                src="../../assets/images/CreativeSpaceLogo.png"
                width="130px"
                contain
                height="70px"
                class="mt-2"
              ></v-img>
            </v-flex>
  
            <v-flex xs12 sm12 md8 lg8 xl8 align-self-center>
              <v-layout wrap justify-center>
                <v-flex xs12 sm12 md12 lg12 xl12 class="text-center">
                  <span
                    class="gold"
                    style="font-family: Jost-Regular;font-weight: 500; font-size: 25px;"
                  >
                    ADMIN PANEL PORTAL
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
  
            <v-flex xs12 sm12 md2 lg2 xl2 align-self-center class="text-center" style="cursor: pointer;" @click="logOutDial()">
              <span style="font-family: Jost-Regular; font-size: 18px;">Logout&nbsp;<v-icon>mdi-logout</v-icon></span>
            </v-flex>
          </v-layout>
        </v-flex>

      <!-- Mobile Header -->
      <v-flex xs12 sm12 md12 lg12 xl12 class="hidden-md-and-up">
        <v-app-bar absolute color="white" height="65px">
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-img
                src="../../assets/images/logo.png"
                width="100px"
                contain
                height="50px"
                class="mt-2"
              ></v-img>
        </v-app-bar>
      </v-flex>
    </v-layout>

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      color="white"
    >
      <v-list dense>
        <v-list-item-group>
          <v-list-item
            v-for="(item, index) in sidebarItems"
            :key="index"
            :value="index"
            :class="{ activated: selectedItem === index }"
            @click="selectItem(index, item.to)"
          >
            <v-list-item-content>
              <v-list-item-title style="font-size: 18px; font-family: Jost-Regular;"  class="custom-list-item-title">
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="logOutDialog" width="400px">
                    <v-card pa-5>
                      <v-layout wrap justify-center>
                        <v-flex xs12 sm12 md12 lg12 xl12 pa-5>

                        <v-layout wrap justify-center>
                            <v-flex xs12 sm12 md12 lg12 xl12 pt-3 class="text-center">
                                <span style="font-family: Jost-Regular; font-size: 18px">Are you sure ,You want to Logout? </span>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap justify-end>    
                          <v-flex xs12 sm5 md5 lg5 xl12>       
                            <v-layout wrap justify-center>       
                              <v-flex xs6 sm6 md6 lg6 xl6 class="text-center" pt-3 pr-sm-2>
                                <v-btn @click="closeLogoutDialog()"><span>No</span></v-btn>
                              </v-flex>
                              <v-flex xs6 sm6 md6 lg6 xl6 class="text-center" pt-3 pl-sm-2>
                                <v-btn style="background-color: #E34234;" @click="logOut()"><span style="color: white;">Yes</span></v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                      </v-flex>
                    </v-layout>
                    </v-card>
                </v-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      drawer: false, // Controls the navigation drawer
      selectedItem: null, // Tracks the currently selected sidebar item
      sidebarItems: [
        { name: "Webpage", to: "/webPages" },
        { name: "Categories", to: "/category" },
        { name: "Products", to: "/products" },
        { name: "Materials", to: "/materialGroup" },
        { name: "About Us", to: "/aboutUs" },
        { name: "Contact Us", to: "/contactUs" },
        { name: "Quote Us", to: "/quoteUs" },
        { name: "Logout", action: this.logOutDial }
      ],

      logOutDialog: false,
    };
  },
  watch: {
    $route() {
      this.updateSelectedItem();
    },
  },
  mounted() {
    this.updateSelectedItem();
  },
  methods: {
    selectItem(index, to) {
    const selectedItem = this.sidebarItems[index];
    
    if (this.selectedItem === index) {
      return; // Prevent deactivation on clicking the same item
    }

    this.selectedItem = index;

    if (selectedItem.action) {
      selectedItem.action(); // Execute the action if it exists
    } else if (to && to !== this.$route.path) {
      this.$router.push(to);
    }
  },
  updateSelectedItem() {
    const currentRoute = this.$route.path;
    const foundIndex = this.sidebarItems.findIndex((item) => item.to === currentRoute);
    this.selectedItem = foundIndex !== -1 ? foundIndex : null;
  },
    logOutDial(){
      this.logOutDialog = true;
    },
    logOut() {
      this.$store.commit("logoutUser", true);
    },

    closeLogoutDialog() {
    this.logOutDialog = false;
    this.updateSelectedItem(); // Update selected item to the current page path
  },
  },
};
</script>

<style>

.fixedSidebar {
  overflow-y: auto;
}
.text-uppercase {
  text-transform: uppercase;
}
.activated {
  background-color: #A77749 !important;
  color: white !important;
  font-weight: bold;
}

.custom-list-item-title {
  font-size: 18px;
  font-family: Jost-Regular;
  line-height: 1.5; /* Ensures enough height for descenders like 'g', 'y', etc. */
  padding: 4px 0;   /* Adds vertical space to prevent clipping */
}

.gold{
    color: #A77749;
}
.searchbar{
    border-radius: 20px;
}
.custom-btn {
  font-size: 16px; /* Default size */
  padding: 8px 16px;
}
@media (min-width: 960px) and (max-width: 1264px) { /* md screens */
  .custom-btn {
    font-size: 14px; /* Smaller size */
    padding: 6px 12px;
  }
}

</style>